module.exports = __webpack_public_path__ + "img/banner-credit.8cdb6c0b.jpg";